import { render, staticRenderFns } from "./Form20CaseInformation.vue?vue&type=template&id=043a4013&scoped=true"
import script from "./Form20CaseInformation.vue?vue&type=script&lang=ts"
export * from "./Form20CaseInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043a4013",
  null
  
)

export default component.exports